import React, { Component } from "react";

class SettingsModal extends Component {
    state = {
        inputsPath: localStorage.getItem("inputsPath") || "",
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSave = () => {
        const { inputsPath } = this.state;

        if (!inputsPath) {
            alert("Please fill all the fields before saving.");
            return;
        }
        localStorage.setItem("inputsPath", inputsPath);
        this.props.closeModal();
        window.location.reload();
    };

    render() {
        const { inputsPath } = this.state;
        const { closeModal } = this.props;

        return (
            <div
                className="position-fixed top-0 start-0 w-100 h-100"
                style={{ background: "rgba(0,0,0,0.4)", zIndex: 9999 }}
            >
                <div
                    className="bg-white rounded shadow p-4 position-absolute"
                    style={{
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: "500px",
                    }}
                >
                    {/* Header with Close Icon */}
                    <div className="position-relative mb-4">
                        <h4 className="text-center fw-bold py-2">Settings</h4>
                        <button
                            className="btn position-absolute end-0 top-0 mt-1 me-2"
                            onClick={() => {
                                const { inputsPath } = this.state;
                                if (!inputsPath) {
                                    alert("Please fill all fields before closing.");
                                    return;
                                }
                                closeModal();
                            }}
                            aria-label="Close"
                        >
                            <i className="bi bi-x-lg fs-4"></i>
                        </button>
                    </div>

                    {/* Input Fields */}
                    {[
                        { label: "Folder path", name: "inputsPath", value: inputsPath }
                    ].map(({ label, name, value }) => (
                        <div key={name} className="mb-3">
                            <label className="">{label}</label>
                            <div className="mt-2">
                                <input
                                    type="text"
                                    className="form-control border-3"
                                    name={name}
                                    value={value}
                                    onChange={this.handleChange}
                                />
                            </div>
                        </div>
                    ))}

                    {/* Buttons */}
                    <div className="d-flex justify-content-center gap-3 mt-4">
                        <button
                            className="btn btn-dark px-5 py-3"
                            style={{ background: "#193e6c" }}
                            onClick={this.handleSave}
                        >
                            Save &nbsp; →
                        </button>
                        <button
                            className="btn px-5 py-3 border-2"
                            style={{ border: "2px solid #193e6c" }}
                            onClick={() => {
                                const { inputsPath } = this.state;
                                if (!inputsPath) {
                                    alert("Please fill all fields before closing.");
                                    return;
                                }
                                closeModal();
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default SettingsModal;
